import { render, staticRenderFns } from "./simplifyOwnerComplaint.vue?vue&type=template&id=45c631c2&scoped=true"
import script from "./simplifyOwnerComplaint.vue?vue&type=script&lang=js"
export * from "./simplifyOwnerComplaint.vue?vue&type=script&lang=js"
import style0 from "./simplifyOwnerComplaint.vue?vue&type=style&index=0&id=45c631c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c631c2",
  null
  
)

export default component.exports